// extracted by mini-css-extract-plugin
export var header = "styles-module--header--Y42hz";
export var desktopHeader = "styles-module--desktopHeader--v-d5O";
export var mobileHeader = "styles-module--mobileHeader--v9gcq";